export const categoryTemplatesSelector = state => state.categoryTemplates || [];
